<template>
  <div class="scr-tp-wrp only-mobile">
      <div v-if="show && active" class="scr-btn-wrp"
      @click="scrollTop()">
          <img class="scr-icon" src="/img/arrow_up_scroll.svg" alt="arrow_up">
          <p class="scr-txt">Top</p>
      </div>
  </div>
</template>

<script>
import {tween} from "popmotion";
export default {
    data(){
        return{
            show:false,
            active:true
        }
    },

    methods:{
        scrolling(){
            let screenHeight = window.innerHeight / 2
            if(window.scrollY > screenHeight){
                this.show = true
            }else{
                this.show = false
            } 
        },

        scrollTop(){
            let t = tween({
                    from:Number(window.scrollY),
                    to:Number(0),
                    duration:500
            });
            t.start((val)=> window.scroll(val,val))
            //window.scroll({ top: 0, behavior: 'smooth' });
        }
    },

    mounted(){
        window.addEventListener('scroll',this.scrolling)
    }
}
</script>

<style scoepd>
.scr-tp-wrp{
    position: fixed;
    bottom: 13%;
    right: 6%;
    z-index: 1000;
}
.scr-btn-wrp{
    cursor: pointer;
    width: 45px;
    height: 45px;
    background: #007d43;
    color: white;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    flex-direction: column;
    border-radius: 50%;
    box-shadow: 0px 3px 6px #00000029;
}
.scr-btn-wrp:hover{
    opacity: .9;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/layouts/MobileScrollUp.vue